import { mpx } from '@didi/es-mpx-creator'
import { getTrainList, getTrainDetail, getMultiTrainList } from '@/api/train'
import { cloneDeep } from 'lodash'
import store from '@/store'


export default {
  getTrainList({ state, commit }, options) {
    const isPaging = options.page_number > 1
    options = {
      ...options,
      user_group: store.state.common.userGroup
    };
    return getTrainList(options)
      .then(res => {
        const { data, code } = res || {}
        if (data || code == '0') {
          const cloneData = cloneDeep(data)
          if(isPaging) {
            const list = data?.list || []
            const trainList = state.trainList?.concat(list)
            cloneData.list = trainList
          }
          commit('setTrainList', { ...cloneData })
        }
        return res
      })
      .finally(() => {
        mpx.hideLoading()
      })
  },
  getMultiTrainList({ commit }, options) {
    options = {
      ...options,
      user_group: store.state.common.userGroup
    };
    return getMultiTrainList(options)
      .then(res => {
        const { data, code } = res || {}
        if (data || code == '0') {
          commit('setTrainList', { ...data })
        }
        return res
      })
      .finally(() => {
        mpx.hideLoading()
      })
  },
  getTrainDetail({ commit }, options) {
    const userGroup = store.state.common.userGroup
    options = {
      ...options,
      user_group: userGroup
    };
    const { refreshType, noNeedStorage } = options;
    if (!refreshType) commit('setTrainDetail', {});
    // mpx.showLoading()
    return getTrainDetail(options)
      .then(res => {
        const { data, code } = res || {}
        if (data || code == '0') {
          commit('setTrainDetail', { ...data, refreshType, userGroup, noNeedStorage });
          if(userGroup && data && data.is_ticket_period !== undefined) {
            store.commit('makeOrder.setMakeOrderLoginType', data.is_ticket_period ? 1 : 0)
          }
        }
        return res
      })
      // .finally(() => {
      //   mpx.hideLoading()
      // })
  }
}
